import { useState } from "react";

const useCalendarStats = () => {
  const [calendarStats, setCalendarStats] = useState({
    totalEvents: 0,
    thisMonth: 0,
    upcoming: 0,
    completed: 0,
    meetings: 0,
    deadlines: 0,
    vacationDays: 0,
    productivity: 85,
    weeklyHours: 42.5,
    overdueEvents: 3,
    todayEvents: 5,
    thisWeekEvents: 12,
  });

  const updateCalendarStats = (eventList = [], vacationDates = new Set()) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    const today = new Date().toDateString();

    const stats = {
      totalEvents: eventList.length,
      thisMonth: eventList.filter((e) => {
        const eventDate = new Date(e.date);
        return (
          eventDate.getMonth() === currentMonth &&
          eventDate.getFullYear() === currentYear
        );
      }).length,
      upcoming: eventList.filter((e) => new Date(e.date) > now).length,
      completed: eventList.filter((e) => e.status === "completed").length,
      meetings: eventList.filter((e) => e.type === "meeting").length,
      deadlines: eventList.filter((e) => e.type === "deadline").length,
      vacationDays: vacationDates.size,
      productivity: Math.min(
        95,
        70 +
          (eventList.filter((e) => e.status === "completed").length /
            Math.max(1, eventList.length)) *
            25
      ),
      weeklyHours: eventList
        .filter((e) => {
          const eventDate = new Date(e.date);
          return eventDate >= startOfWeek && eventDate <= endOfWeek;
        })
        .reduce((total, e) => total + e.duration / 60, 0),
      overdueEvents: eventList.filter(
        (e) => new Date(e.date) < now && e.status !== "completed"
      ).length,
      todayEvents: eventList.filter(
        (e) => new Date(e.date).toDateString() === today
      ).length,
      thisWeekEvents: eventList.filter((e) => {
        const eventDate = new Date(e.date);
        return eventDate >= startOfWeek && eventDate <= endOfWeek;
      }).length,
    };

    setCalendarStats(stats);
  };

  return { calendarStats, updateCalendarStats };
};

export default useCalendarStats;
